/* eslint-disable @typescript-eslint/no-explicit-any */
import { RECTANGLE_1 } from 'assets/images';
import { convertTimestampToDate, shortenRaceNameV2 } from 'utils/helper';

import InforBoxContainer from './styled';
import { useAppSelector } from 'hooks';
import { GUILD_MESSAGE } from 'i18n/constants';
import { useTranslation } from 'react-i18next';
import Button from 'shared/Button';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from 'hooks';
import { updateStateModal } from 'features/Profile/profile.slice';

interface masterGuild {
  max_member: number
  exp_to_level_up: number
  max_horse: number
  name: string
}

interface infoProps {
  informationData: {
    avatar: string
    guild_tag: string
    name: string
    level: string
    created?: any
    role_in_guild: string
    total_member: number
    master_guild_level: masterGuild
    total_horse: number
    total_exp: number
    guild_master: string
    guild_master_id: number
  }
}

const InforBox = ({ informationData }: infoProps) => {
  const { profile } = useAppSelector(state => state)
  const { t } = useTranslation()
  const navigate = useNavigate()

  const dispatch = useAppDispatch()
  const showModalInfo = () => {
    dispatch(updateStateModal({
      isOpen: true,
      userId: informationData?.guild_master_id,
    }))
  }
  return (
    <InforBoxContainer>
      <div className='info-box'>
        <div className='head'>
          <p>Guild info</p>
          <img src={RECTANGLE_1} alt='line' />
        </div>

        <div className='row'>
          <span>Founded in</span>
          <span>{convertTimestampToDate(informationData?.created)}</span>
        </div>
        <div className='row'>
          <span>Guild master</span>
          <span onClick={showModalInfo}>{shortenRaceNameV2(informationData?.guild_master, 12)}</span>
        </div>
        <div className='row'>
          <span>Members</span>
          <span>{informationData?.total_member}/{informationData?.master_guild_level?.max_member}</span>
        </div>
        <div className='row'>
          <span>Horses</span>
          <span>{informationData?.total_horse}/{informationData?.master_guild_level?.max_horse}</span>
        </div>
        <div className='row'>
          <span>EXP</span>
          <span>{informationData?.total_exp}/{informationData?.master_guild_level?.exp_to_level_up}</span>
        </div>
        {profile?.role_in_guild === 'MASTER' && (
          <div className='button-edit'>
            <Button
              buttonName={<div>{t(`${GUILD_MESSAGE}.upgradeAct`)}</div>}
              width={147}
              onClickButton={() => navigate("/guild/edit/upgrade")}
            />
          </div>
        )}
      </div>
    </InforBoxContainer>
  )
}

export default InforBox
